exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cp-mixtime {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.cp-mixtime .tabs {\n  width: 120px;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 36px;\n  border: 1px solid #e5e5e5;\n  cursor: pointer;\n}\n.cp-mixtime .tabs div {\n  width: 120px;\n  height: 100%;\n  background-color: #fff;\n  color: #999;\n  font-size: 14px;\n  text-align: center;\n}\n.cp-mixtime .tabs div:first-child {\n  border-radius: 5px 0 0 5px;\n}\n.cp-mixtime .tabs div:last-child {\n  border-radius: 0 5px 5px 0;\n}\n.cp-mixtime .tabs .active-tab {\n  color: #333;\n  font-weight: bold;\n  background-color: #f5f5f5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/components/mixtime/index.less
// module id = 643
// module chunks = 0